import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@cargomatic/ui';
import { useTranslation } from 'react-i18next';

export function ConfirmationModal({
  title,
  description,
  open = false,
  onHide,
  onConfirm,
  cancelText,
  confirmText,
}) {
  const { t } = useTranslation();
  return (
    <AlertDialog open={open} onOpenChange={onHide}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          {description && (
            <AlertDialogDescription>{description}</AlertDialogDescription>
          )}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{cancelText || t('CANCEL')}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            {confirmText || t('CONFIRM')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
